var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeposit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 2085662215"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 63,
    stroke: "var(--stroke-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M37.5455 17C37.9915 17 38.4193 17.1756 38.7347 17.4882C39.0501 17.8007 39.2273 18.2246 39.2273 18.6667V22H45.9545C46.4006 22 46.8284 22.1756 47.1438 22.4882C47.4592 22.8007 47.6364 23.2246 47.6364 23.6667V43.6667H51V47H14V43.6667H17.3636V23.6667C17.3636 23.2246 17.5408 22.8007 17.8562 22.4882C18.1716 22.1756 18.5994 22 19.0455 22H25.7727V18.6667C25.7727 18.2246 25.9499 17.8007 26.2653 17.4882C26.5807 17.1756 27.0085 17 27.4545 17H37.5455ZM25.7727 25.3333H20.7273V43.6667H25.7727V25.3333ZM35.8636 25.3333H29.1364V43.6667H35.8636V25.3333ZM44.2727 25.3333H39.2273V43.6667H44.2727V25.3333ZM35.8636 20.3333H29.1364V22H35.8636V20.3333Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeposit);
export default __webpack_public_path__ + "static/media/deposit.4849b2a43e0b7ed548092ddc06739caf.svg";
export { ForwardRef as ReactComponent };